import lodash from "lodash";

import { dayjs } from "@holibob-packages/dayjs";

export const orderByDuration = <T extends { duration?: string | null }>(
    cancellationPenalties: T[],
    order: "asc" | "desc"
): T[] => {
    return lodash.orderBy(
        cancellationPenalties,
        ({ duration }) => {
            if (!duration) return Infinity;
            return dayjs.duration(duration).asSeconds();
        },
        order
    );
};
